// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Roboto/Roboto-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Roboto/Roboto-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Roboto/Roboto-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/Roboto/Roboto-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/Roboto/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/Roboto/Roboto-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/Roboto/Roboto-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("assets/fonts/Roboto/Roboto-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("assets/fonts/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("assets/fonts/Roboto/Roboto-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("assets/fonts/Roboto/Roboto-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-style: normal;
  font-weight: 925;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-style: italic;
  font-weight: 925;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-style: italic;
  font-weight: 700;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-style: italic;
  font-weight: 400;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-style: normal;
  font-weight: 300;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-style: italic;
  font-weight: 300;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-style: normal;
  font-weight: 500;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-style: italic;
  font-weight: 500;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-style: normal;
  font-weight: 400;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  font-style: normal;
  font-weight: 100;
}
@font-face {
  font-family: "Roboto";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  font-style: italic;
  font-weight: 100;
}
html {
  overflow: hidden;
}

body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.rw-widget-picker {
  margin-bottom: 16px;
}
.rw-widget-picker .rw-widget-input {
  box-shadow: unset;
}
.rw-widget-picker .rw-input-addon {
  border-left: 0;
}

.form-control:focus,
.rw-combobox.rw-widget.rw-state-focus .rw-widget-picker,
.rw-date-picker.rw-widget.rw-state-focus .rw-widget-picker {
  border-color: #89C3BF;
  box-shadow: 0 0 0 3px rgb(137, 195, 191);
  transition: box-shadow 0.15s ease-in-out;
}

.rw-combobox.rw-widget .input-error.rw-widget-picker,
.rw-date-picker.rw-widget .input-error.rw-widget-picker {
  border-color: #DC3545;
  box-shadow: 0 0 0 3px rgb(220, 53, 69);
  transition: box-shadow 0.15s ease-in-out;
}

.Toastify__toast-container.Toastify__toast-container--top-right {
  width: 400px;
}

.Toastify__toast-container .Toastify__toast {
  background-color: #198754;
}

.Toastify__toast-body {
  color: white;
}

button:hover .svg-arrow-path, button:disabled .svg-arrow-path {
  fill: white;
}

main {
  height: 100vh;
}

.lh-zero {
  line-height: 0 !important;
}

.w-max-content {
  width: max-content;
}

input[type=checkbox]:focus {
  box-shadow: none;
  border-color: #dee2e6;
  -webkit-box-shadow: none;
}

input.custom-check:checked {
  background-color: #00857C;
  border-color: #00857C;
}
input.custom-check:indeterminate {
  background-color: #00857C !important;
  border-color: #00857C !important;
}

.custom-button.btn-outline-primary {
  --bs-btn-color: #00857C;
  --bs-btn-border-color: #00857C;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #00857C;
  --bs-btn-hover-border-color: #00857C;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #00857C;
  --bs-btn-active-border-color: #00857C;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #86C2BF;
  --bs-btn-disabled-border-color: #86C2BF;
  --bs-gradient: none;
}
.custom-button.btn-light {
  --bs-btn-bg: #fff;
  --bs-btn-border-color: #d3d4d5;
  --bs-btn-hover-border-color: #d3d4d5;
  --bs-btn-active-border-color: #d3d4d5;
  --bs-btn-disabled-color: #d3d4d5;
  --bs-btn-disabled-bg: #fff;
  --bs-btn-disabled-border-color: #d3d4d5;
}

#icon-title-tooltip {
  z-index: 2;
}

.react-tooltip {
  font-size: 14px !important;
  font-weight: 400 !important;
}

.custom-modal {
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  display: block;
  position: fixed;
  top: 20vh;
  height: auto;
  margin: 0 auto;
  z-index: 100;
  width: 100%;
}

.custom-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  background-color: black;
  opacity: 0.3;
}`, "",{"version":3,"sources":["webpack://./src/index.scss","webpack://./src/styles/global-variables.scss","webpack://./src/styles/custom.scss"],"names":[],"mappings":"AACA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AAAF;AAGA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AADF;AAIA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AAFF;AAKA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AAHF;AAMA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AAJF;AAOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AALF;AAQA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AANF;AASA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AAPF;AAUA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AARF;AAWA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;EACA,gBAAA;AATF;AAYA;EACE,qBAAA;EACA,6CAAA;EACA,kBAAA;EACA,gBAAA;AAVF;AAcA;EACE,gBAAA;AAZF;;AAeA;EACE,SAAA;EACA,8JAAA;EAGA,mCAAA;EACA,kCAAA;AAdF;;AAiBA;EACE,mBAAA;AAdF;AAgBE;EACE,iBAAA;AAdJ;AAiBE;EACE,cAAA;AAfJ;;AAmBA;;;EAGE,qBAAA;EACA,wCAAA;EACA,wCAAA;AAhBF;;AAmBA;;EAEE,qBAAA;EACA,sCAAA;EACA,wCAAA;AAhBF;;AAmBA;EACE,YAAA;AAhBF;;AAmBA;EACE,yBAAA;AAhBF;;AAmBA;EACE,YAAA;AAhBF;;AAuBI;EACE,WAAA;AApBN;;AAyBA;EACE,aAAA;AAtBF;;AA2BA;EACE,yBAAA;AAxBF;;AA2BA;EACE,kBAAA;AAxBF;;AA2BA;EACE,gBAAA;EACA,qBCxJY;EDyJZ,wBAAA;AAxBF;;AErII;EACI,yBAAA;EACA,qBAAA;AFwIR;AErII;EACI,oCAAA;EACA,gCAAA;AFuIR;;AElII;EACI,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;EACA,mBAAA;AFqIR;AElII;EACI,iBAAA;EACA,8BAAA;EACA,oCAAA;EACA,qCAAA;EACA,gCAAA;EACA,0BAAA;EACA,uCAAA;AFoIR;;AEhIA;EACI,UDzBqB;AD4JzB;;AAVA;EACE,0BAAA;EACA,2BAAA;AAaF;;AAVA;EACE,uBAAA;EACA,oCAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,SAAA;EACA,YAAA;EACA,cAAA;EACA,YClKY;EDmKZ,WAAA;AAaF;;AAVA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,WC3KoB;ED4KpB,uBAAA;EACA,YAAA;AAaF","sourcesContent":["@use \"/home/runner/_work/gmc-dc-pbui-fe/gmc-dc-pbui-fe/src/styles/global-variables.scss\" as *;\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-Black.ttf\");\n  font-style: normal;\n  font-weight: 925;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-BlackItalic.ttf\");\n  font-style: italic;\n  font-weight: 925;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-BoldItalic.ttf\");\n  font-style: italic;\n  font-weight: 700;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-Italic.ttf\");\n  font-style: italic;\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-Light.ttf\");\n  font-style: normal;\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-LightItalic.ttf\");\n  font-style: italic;\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-Medium.ttf\");\n  font-style: normal;\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-MediumItalic.ttf\");\n  font-style: italic;\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-Regular.ttf\");\n  font-style: normal;\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-Thin.ttf\");\n  font-style: normal;\n  font-weight: 100;\n}\n\n@font-face {\n  font-family: \"Roboto\";\n  src: url(\"assets/fonts/Roboto/Roboto-ThinItalic.ttf\");\n  font-style: italic;\n  font-weight: 100;\n}\n\n\nhtml {\n  overflow: hidden;\n}\n\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.rw-widget-picker {\n  margin-bottom: 16px;\n\n  .rw-widget-input {\n    box-shadow: unset;\n  }\n\n  .rw-input-addon {\n    border-left: 0;\n  }\n}\n\n.form-control:focus,\n.rw-combobox.rw-widget.rw-state-focus .rw-widget-picker,\n.rw-date-picker.rw-widget.rw-state-focus .rw-widget-picker {\n  border-color: #89C3BF;\n  box-shadow: 0 0 0 3px rgba(137, 195, 191, 1);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.rw-combobox.rw-widget .input-error.rw-widget-picker,\n.rw-date-picker.rw-widget .input-error.rw-widget-picker {\n  border-color: #DC3545;\n  box-shadow: 0 0 0 3px rgba(220, 53, 69, 1);\n  transition: box-shadow 0.15s ease-in-out;\n}\n\n.Toastify__toast-container.Toastify__toast-container--top-right {\n  width: 400px;\n}\n\n.Toastify__toast-container .Toastify__toast {\n  background-color: #198754;\n}\n\n.Toastify__toast-body {\n  color: white;\n}\n\nbutton {\n\n  &:hover,\n  &:disabled {\n    .svg-arrow-path {\n      fill: white;\n    }\n  }\n}\n\nmain {\n  height: 100vh;\n}\n\n// bootstrap like utilities\n\n.lh-zero {\n  line-height: 0 !important;\n}\n\n.w-max-content {\n  width: max-content;\n}\n\ninput[type=\"checkbox\"]:focus {\n  box-shadow: none;\n  border-color: $borderColor;\n  -webkit-box-shadow: none;\n}\n\n@import './styles/custom.scss';\n\n.react-tooltip {\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n\n.custom-modal {\n  background-color: white;\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: 5px;\n  display: block;\n  position: fixed;\n  top: 20vh;\n  height: auto;\n  margin: 0 auto;\n  z-index: $zIndexModal;\n  width: 100%;\n}\n\n.custom-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: $zIndexModalBackdrop;\n  background-color: black;\n  opacity: 0.3;\n}","$navbarHeight: 50px;\n\n$clearSectionButtonColor: #6C757D;\n$clearAllButtonPrimary: #F8F9FA;\n$clearAllButtonDisabled: #A1BFBE;\n$borderColor: #dee2e6;\n\n$buttonBorderRadius: 3.2px;\n\n$buttonFontSize: 14px;\n\n$zIndexSimulationDisclaimer: 1000;\n$zIndexSectionWithLayoutVariantsHover: 200;\n$zIndexSectionHighlighted: 100;\n$zIndexSectionStickyPanel: 100;\n$zIndexModal: 100;\n$zIndexModalBackdrop: 10;\n$zIndexIconTitleTooltip: 2;\n$zIndexScreen: 2;\n$zIndexScreenBackdrop: 1;\n$zIndexLayoutPreviewListStickyPanel: 1;\n$zIndexTextCollectionsModalTh: 1;\n","input.custom-check {\n    &:checked {\n        background-color: #00857C;\n        border-color: #00857C;\n    }\n\n    &:indeterminate {\n        background-color: #00857C !important;\n        border-color: #00857C !important;\n    }\n}\n\n.custom-button {\n    &.btn-outline-primary {\n        --bs-btn-color: #00857C;\n        --bs-btn-border-color: #00857C;\n        --bs-btn-hover-color: #fff;\n        --bs-btn-hover-bg: #00857C;\n        --bs-btn-hover-border-color: #00857C;\n        --bs-btn-focus-shadow-rgb: 13, 110, 253;\n        --bs-btn-active-color: #fff;\n        --bs-btn-active-bg: #00857C;\n        --bs-btn-active-border-color: #00857C;\n        --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);\n        --bs-btn-disabled-color: #fff;\n        --bs-btn-disabled-bg: #86C2BF;\n        --bs-btn-disabled-border-color: #86C2BF;\n        --bs-gradient: none;\n    }\n\n    &.btn-light {\n        --bs-btn-bg: #fff;\n        --bs-btn-border-color: #d3d4d5;\n        --bs-btn-hover-border-color: #d3d4d5;\n        --bs-btn-active-border-color: #d3d4d5;\n        --bs-btn-disabled-color: #d3d4d5;\n        --bs-btn-disabled-bg: #fff;\n        --bs-btn-disabled-border-color: #d3d4d5;\n    }\n}\n\n#icon-title-tooltip {\n    z-index: $zIndexIconTitleTooltip;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
